<template>
  <section class="office-scenarios">
    <h2 class="section-title">{{ $t('office.scenarios.title') }}</h2>
    <div class="scenarios-grid">
      <div v-for="(scenario, index) in scenarios" :key="scenario.title" class="scenario-card">
        <div class="scenario-image">
          <img :src="scenario.imageUrl" :alt="scenario.title" />
          <div class="image-overlay">
            <Icon :name="scenario.icon" class="scenario-icon" />
          </div>
        </div>
        <div class="scenario-content">
          <h3 class="scenario-title">{{ scenario.title }}</h3>
          <p class="scenario-description">{{ scenario.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const scenarios = computed(() => [
  {
    title: t('office.scenarios.items.0.title'),
    description: t('office.scenarios.items.0.description'),
    icon: 'material-symbols:business-center',
    imageUrl: '/images/scenarios/business-scenario.jpg'
  },
  {
    title: t('office.scenarios.items.1.title'),
    description: t('office.scenarios.items.1.description'),
    icon: 'material-symbols:school',
    imageUrl: '/images/scenarios/academic-scenario.jpg'
  },
  {
    title: t('office.scenarios.items.2.title'),
    description: t('office.scenarios.items.2.description'),
    icon: 'material-symbols:person',
    imageUrl: '/images/scenarios/personal-office-scenario.jpg'
  },
  {
    title: t('office.scenarios.items.3.title'),
    description: t('office.scenarios.items.3.description'),
    icon: 'material-symbols:groups',
    imageUrl: '/images/scenarios/team-collaboration-scenario.jpg'
  }
])
</script>

<style scoped>
.office-scenarios {
  padding: 4rem 0;
  background: #f8f9fa;
}

.section-title {
  text-align: center;
  font-size: 2rem;
  color: #2c3e50;
  margin-bottom: 3rem;
}

.scenarios-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.scenario-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease;
}

.scenario-card:hover {
  transform: translateY(-8px);
}

.scenario-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.scenario-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-overlay {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  padding: 0.75rem;
}

.scenario-icon {
  font-size: 1.5rem;
  color: #4A90E2;
}

.scenario-content {
  padding: 1.5rem;
}

.scenario-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.75rem;
}

.scenario-description {
  color: #6c757d;
  line-height: 1.6;
}
</style>
